<div class="wrapper--search">
  <ark-icon icon="system-search" color="dark" size="small"></ark-icon>
  <input
    type="text"
    class="form--input-search"
    [formControl]="searchControl"
    [placeholder]="placeholder"
  />
</div>
